export const ROLES = {
  BRANCH: "branch",
  VENDOR: "vendor",
  CASHIER: "cashier",
  AUTH: "auth",
};
